export function trackPixelEvent(
  eventName: 'StartTrial',
  eventProps: Record<string, number | string | boolean> = {},
  eventId: string
) {
  // @ts-expect-error fbq is a global function added by meta pixel
  fbq('track', eventName, eventProps, { eventID: eventId });
}
